import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

import { ErrorType } from '@/types';

import './steps/fg-step-upload';
import './steps/fg-step-upload-success';
import './steps/fg-step-uploading';

@customElement('fg-file-upload')
@localized()
export class FgFileUpload extends LitElement {
  @state()
  private file?: File | null;

  @state()
  private fileName = '';

  @state()
  private uploadStep = 1;

  @state()
  private errorMessage = '';

  private fileUploadStart(event: CustomEvent) {
    const { fileName, file } = event.detail;
    this.fileName = fileName;
    this.file = file;
    this.uploadStep++;
  }

  private resetUpload() {
    this.file = null;
    this.fileName = '';
    this.uploadStep = 1;
  }

  private fileUploadedSuccess(event: CustomEvent) {
    this.uploadStep++;
    this.dispatchEvent(
      new CustomEvent('file-upload-success', {
        detail: {
          uuid: event.detail,
        },
      }),
    );
  }

  private fileErrorHandler(event: CustomEvent) {
    const error = event.detail;

    switch (error) {
      case ErrorType.FILE_SIZE:
        this.errorMessage = t('errors.fileTooLarge');
        break;
      case ErrorType.FILE_EXTENSION:
        this.errorMessage = t('errors.formatNotAllowed');
        break;
      case typeof error === 'string':
        this.errorMessage = error;
        break;
      case null:
        this.errorMessage = '';
        break;
      default:
        this.errorMessage = t('errors.somethingWentWrong');
        break;
    }
    this.resetUpload();

    this.dispatchEvent(
      new CustomEvent('file-upload-error', {
        detail: { errorMessage: this.errorMessage },
      }),
    );
  }

  render() {
    switch (this.uploadStep) {
      case 1:
        return html`
          <fg-step-upload
            @upload-error=${this.fileErrorHandler}
            @start-upload=${this.fileUploadStart}
          ></fg-step-upload>
        `;
      case 2:
        return html`
          <fg-step-uploading
            .file=${this.file}
            @file-uploaded-successfully=${this.fileUploadedSuccess}
            @upload-error=${this.fileErrorHandler}
          ></fg-step-uploading>
        `;
      case 3:
        return html`
          <fg-step-upload-success
            .fileName=${this.fileName}
            @reset-upload=${this.resetUpload}
          ></fg-step-upload-success>
        `;
    }
  }
}
